module.exports = __webpack_public_path__ + "images/skoda7de93ed1a3a7de2ebd8a33b672a4b89b.png";